import { TASK_TYPE } from "../../constants";

export const changePencilModeColor = color => {
  return { type: TASK_TYPE.CHANGE_PENCIL_MODE_COLOR, payload: { color } };
};
